import bg from "../assets/villa1.jpg";

export default function Hero() {
  return (
    <header
      id="hero"
      className="hero"
      style={{
        backgroundImage: `url(${bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <h1>Mardacannes Residence</h1>
      <p>Enhancing luxury living with memorable moments</p>
      <a href="#overview">Discover More</a>
    </header>
  );
}
